import { useEffect, useReducer, useState } from "react";
import {
  AppShell,
  Burger,
  Group,
  ScrollArea,
  rem,
  Image,
  Divider,
  Title,
  UnstyledButton,
  Box,
} from "@mantine/core";
import logo from "../assets/android-chrome-192x192.png";
import { Link, Outlet, useNavigate } from "react-router-dom";
import { useDisclosure } from "@mantine/hooks";
import { IconAlertCircle } from "@tabler/icons-react";
import { notifications } from "@mantine/notifications";
import { url } from "../settings/linkUrl";
import MenuUser from "../components/MenuUser";
import UserProfile from "../components/UserProfile";
import { LinksGroup } from "../components/NavbarLinksGroup";
import nested from "./NavbarNested.module.css";
import shell from "./AdministratorLayout.module.css";
import "../(administrators)/admin-theme.css";

interface LinksGroupProps {
  icon: string;
  label: string;
  initiallyOpened: boolean;
  link: string;
  links: { label: string; link: string }[];
}

interface RowDataUser {
  id: string;
  url: string;
  faculty: string;
  programe: string;
  short_name: string;
  role: string;
  name: string;
}

const initialmockdata: LinksGroupProps[] = [];

function AdministratorLayout() {
  const [opened, { toggle, close: closeMobileNav }] = useDisclosure();
  const [mockdata, setmockdata] = useState(initialmockdata);

  const initialState = {
    loading: "",
    error: "",
    data: [],
  };

  function apiReducer(state: any, action: any) {
    switch (action.type) {
      case "DATA_FETCH_START":
        return { ...state, loading: "yes" };
      case "DATA_FETCH_SUCCESS":
        return { ...state, loading: "", data: action.payload };
      case "DATA_FETCH_FAILURE":
        return { ...state, loading: "", error: action.payload };
      default:
        return state;
    }
  }

  const [, dispatch] = useReducer(apiReducer, initialState);
  const [dataUser, SetdataUser] = useState<RowDataUser>();

  const loadlistmenu = async () => {
    const token = localStorage.getItem("token");
    const requestOptions = {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    await fetch(`${url}listmenu/listmenu`, requestOptions)
      .then((respone) => {
        if (!respone.ok) throw Error(respone.statusText);
        return respone.json();
      })
      .then((json) => {
        dispatch({ type: "DATA_FETCH_SUCCESS", payload: json });
        setmockdata(json);
      })
      .catch((error) => {
        dispatch({ type: "DATA_FETCH_FAILURE", payload: error.message });
      });
  };

  const mainLinks = mockdata.map((item) => (
    <LinksGroup {...item} key={item.label} onOpenmenu={closeMobileNav} />
  ));

  const nav = useNavigate();
  const [checkLoad, setCheckLoad] = useState(false);
  const signOut = () => {
    notifications.show({
      title: "แจ้งเตือน",
      message: "ไม่มีสิทธิ์เข้าใช้งานในส่วนนี้",
      autoClose: 3000,
      icon: <IconAlertCircle />,
      color: "red",
    });
    nav(`/`);
    window.localStorage.clear();
  };

  const checkData = () => {
    setCheckLoad(true);
  };

  useEffect(() => {
    checkData();
    if (checkLoad) {
      if (localStorage.getItem("dataUser") === null) {
        signOut();
      }
    }
  }, [checkLoad]);

  const LoadPage = () => {
    let rr: any = localStorage.getItem("dataUser");
    SetdataUser(JSON.parse(rr));
  };

  useEffect(() => {
    loadlistmenu();
    LoadPage();
  }, []);

  return (
    <div className="admin-app">
      <AppShell
        header={{ height: 60 }}
        navbar={{
          width: 280,
          breakpoint: "sm",
          collapsed: { mobile: !opened },
        }}
        padding="md"
      >
        <AppShell.Header className="admin-shell-header">
          <Group justify="space-between" px="md" align="center" h="100%">
            <Group gap="sm" align="center">
              <Burger
                opened={opened}
                onClick={toggle}
                hiddenFrom="sm"
                size="sm"
                color="white"
              />
              <UnstyledButton component={Link} to="/administrator">
                <Group justify="flex-start" align="center" gap="sm">
                  <Image src={logo} w={36} alt="logo" />
                  <Box visibleFrom="xs">
                    <Title order={5} className={shell.brandTitle}>
                      ระบบเจ้าหน้าที่
                      <span className={shell.brandSub}>
                        ลงทะเบียนซ้อมรับพระราชทานปริญญาบัตร
                      </span>
                    </Title>
                  </Box>
                </Group>
              </UnstyledButton>
            </Group>
            <Box className={shell.headerRight}>
              <MenuUser
                image={`${dataUser?.url}`}
                name={`${dataUser?.name || ""}`}
                type={dataUser?.role || "ผู้ดูแลระบบ"}
              />
            </Box>
          </Group>
        </AppShell.Header>

        <AppShell.Navbar p="md" className="admin-shell-navbar">
          <ScrollArea
            h={`calc(100vh - ${rem(60)})`}
            mx="-md"
            className={nested.links}
          >
            <div className={shell.profileBox}>
              <UserProfile
                image_user={`${dataUser?.url}`}
                name_user={`${dataUser?.name || ""}`}
                type_user="ผู้ดูแลระบบ"
              />
            </div>

            <Divider my="sm" className={shell.navDivider} />

            <div className={nested.linksInner}>{mainLinks}</div>
          </ScrollArea>
        </AppShell.Navbar>

        <AppShell.Main className="admin-shell-main">
          <div className="admin-page">
            <Outlet />
          </div>
        </AppShell.Main>
      </AppShell>
    </div>
  );
}

export default AdministratorLayout;
